import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpParams } from '@angular/common/http';

const BLDG_URL = "library/api/bldg"; //PROD
// const BLDG_URL = "https://dev1.bats.admin.ufl.edu/library/api/bldg"; //TEST

const PARAMS = new HttpParams({
  fromObject: {
    origin: '*'
  }
});
@Component({
  selector: 'building-dialog',
  templateUrl: 'building-dialog.html',
})
export class BuildingDialog implements OnInit {
  @Input() public bldgName;
  @Input() public bldgNumber;
  @Input() public bldgCode;
  public bldg;
  public bldgGSF = '';
  public bldgABBREV = '';
  public bldgADDRESS1 = '';
  public bldgADDRESS2 = '';
  public bldgCITY = '';
  public bldgSTATE  = '';
  public bldgZIP = '';
  
  constructor(public dialogRef: MatDialogRef<BuildingDialog>, private http: HttpClient) { }
  ngOnInit(): void {
    
  }

  public loadBuilding() {
    this.http
      .get(BLDG_URL, { params: PARAMS.set('bldg', this.bldgNumber) })
      .subscribe((data: any) => {
        this.bldg = data;
        this.bldgName = data.NAME;
        this.bldgADDRESS1 = data.ADDRESS1;
        this.bldgADDRESS2 = data.ADDRESS2;
        this.bldgCITY = data.CITY;
        this.bldgSTATE = data.STATE;
        this.bldgZIP = data.ZIP;
        this.bldgGSF = data.GSF;
      });
  }

  closeDialog() {
    this.dialogRef.close('closed');
  }// end closeDialog
}